export const CHANGE_TYPES = {
    COMMENT: 'comment',
    STATUS: 'status',
    TYPE: 'type',
    PRIORITY: 'priority',
    WORKING_TIME: 'workingTime',
    DESCRIPTION: 'description',
    CREATED_AT: 'createdAt',
    COORDINATOR_ID: 'coordinatorId',
    SERVICEMAN_ID: 'servicemanId',
    SYSTEM: 'system',
    MIGRATED_NOTE: 'migratedNote',
    SCHEDULED_DATE: 'scheduledDate',
    DIFFICULTY: 'difficulty',
    USED_PARTS: 'usedParts',
};

export const IMAGE_CONSTANTS = {
    MAX_FILE_SIZE: 10 * 1024 * 1024,
    MAX_FILES: 10,
    ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
    ALLOWED_TYPES_SET: new Set(['image/jpeg', 'image/png', 'image/webp']),
};

export const SWIPE_CONSTANTS = {
    MIN_SWIPE_DISTANCE: 50,
};

export const IMAGE_DIMENSIONS = {
    THUMBNAIL_SIZE: 120,
    THUMBNAIL_EDITOR_SIZE: 80,
    SLIDER_WIDTH_DESKTOP: 682,
};

export const USER_ROLES = {
    ADMIN: 'ROLE_ADMIN',
    BOK: 'ROLE_BOK',
    SERVICE_MASTER: 'ROLE_SERVICE_MASTER',
    SERVICE: 'ROLE_SERVICE',
};
